import { Helmet } from 'react-helmet-async';
import { TITLES } from '../../../../types/titles';
import CardBePaidLayout from '../../../../components/deposit/card/bepaid';

const CardBePaidDeposit = () => {
	return (
		<>
			<Helmet>
				<title>{TITLES.DEPOSIT.CARD.BEPAID}</title>
			</Helmet>
			<CardBePaidLayout />
		</>
	);
};

export default CardBePaidDeposit;
